import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../style/style.css';
import '../style/sb-admin-2.min.css';
import '../font/css/all.min.css';
import logo from '../img/logos.png';
import {mentorLogin} from '../Firebase/API/mentor';
import {signIn} from '../Firebase/API/auth';
import {getAdmin} from '../Firebase/API/admin';
import {resetPassword} from '../Firebase/API/email';

function Login(props) {

   const [password, setPassword] = useState('');
   const [email, setEmail] = useState('')
   
  
   async function login(e) {
      e.preventDefault();
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (!email || email === "") {
         toast.error("Please enter an Email.");
      }else if(!email.match(mailformat)){
         toast.error("Please enter valid Email.");
      }
      else if(!password || password ===""){
         toast.error("Please enter a Password.");

      }else if(email && password){
          signIn(email,password,async (user,status)=>{
              if(status){
                 if(user.user.uid){
                  // history.push("/profile")
                  getAdmin(user.user.uid,(res,adminStatus)=>{
                     if(adminStatus){
                         if(res){
                             localStorage.setItem('token',res.uid)
                             localStorage.setItem('profile',"admin")
                             props.history.push('/profile');
                         }
                     }else{
                        mentorLogin(user.user.email , (res, status)=>{
                           console.log(status)
                           if(status){
                              if(res){
                              localStorage.setItem('token',res.id)
                              localStorage.setItem('profile',"mentor")
                              props.history.push('/mentorcase')
                              }
                           }else{
                              toast.error("Access denied or May be your account is inactive ");
                           }
                        })
                           // toast.error("Access Denied. Please Try again.");
                     }
                 });
                 }
              }
              else{
                  toast.error("Invalid Credentials.");
              }
          }) 
      }else{
         toast.error("Invalid Email or Password.");
      }
  }
	
   return (
    <div >
    <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"/>
      <div className="row justify-content-center logins ">
         <div className="col-xl-12 col-lg-12 col-md-12 p-0">
            <div className="o-hidden border-0 ">
               <div className="p-0 bg" >
                  <div className="row " >
                     
                     <div className="col-xl-4 col-md-6 col-12 pt-5 login-right col-lg-5">
                        <div className="p-5">
                           <img src={logo} className="img-fluid" alt="Logo"/>
                           {/* <div className="text-center">
                              <h1 className="h4 mt-3 mb-0 text-left">Please login to your account</h1>
                            
                           </div> */}
                      
                           <form className="user">
                              <div className="form-group mt-2">
                                 
                                    <input type="email" className="form-control mt-4" id="emailaddress" required="" 
                                    value={email} onChange={(e) => setEmail(e.target.value)} aria-describedby="emailHelp"
                                    placeholder="Enter your Email"/>

                                     <input type="password" className="form-control mt-4" id="InputPassword" required="" 
                                     value={password} onChange={(e) => setPassword(e.target.value)}
                                     autocomplete="new-password" placeholder="Password"/>
									 
                                 <div className="d-flex justify-content-end mt-4">
                                    <button type="submit"  onClick={(e) => login(e)} className="btn btn-facebook btn-user d-block">
                                    Login 
                                    </button>
                                 </div>
                                 <br></br>
                                 <a href="/forgotpassword" > Forgot Password ?</a>

                              </div>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </div>

   
   );
}

export default Login;

